import { PRODUCT_KEYS } from '../config/studioProducts'
import { ROLES } from '../constants/roles'
import { useOrganization } from '../contexts/OrganizationContext'
import { useAuth } from './useAuth'

// Adding a creator (from the composer's creator menu) is open to editors and
// above who can publish to the Feed; editing, avatars and removal stay with
// useCanManageCreators. The API keeps the same boundary.
export function useCanAddCreators() {
  const { hasProductAccess } = useOrganization()
  const { hasRole } = useAuth()

  return hasRole(ROLES.EDITOR) && Boolean(
    hasProductAccess?.(PRODUCT_KEYS.FEED, 'publish'),
  )
}
